'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('uba', {
      url: '/uba',
      template: '<uba></uba>'
    });
}



// WEBPACK FOOTER //
// ./client/app/uba/uba.routes.js